import {NullableUndefinedNumber, NullableUndefinedString} from "../common/types/nullable-types";
import {Check} from "@sparkware/app-utils";

/**
 * A helper class to get a property value from an object using a case-insensitive match by property name
 * CI = Case-Insensitive
 */
export class CIPropRead {
    static getProperty(propertyName: string, propertyOwner: any): any {
        if(!propertyOwner) {
            return null;
        }
        propertyName = propertyName.toLowerCase();
        for(let propName of Object.keys(propertyOwner)) {
            if(propName.toLowerCase() === propertyName) {
                return propertyOwner[propName];
            }
        }

        return null;
    }

    static getNumericProperty(propertyName: string, propertyOwner: any): NullableUndefinedNumber {
        const value = parseInt(CIPropRead.getProperty(propertyName, propertyOwner));
        if(Check.isNumber(value)) {
            return value;
        }

        return null;
    }

    static getStringProperty(propertyName: string, propertyOwner: any): NullableUndefinedString {
        const value = CIPropRead.getProperty(propertyName, propertyOwner)?.toString();
        if(Check.isString(value)) {
            return value;
        }
        return null;
    }
}